import { render } from "./InputBorder.vue?vue&type=template&id=2b7af3ae&scoped=true"
import script from "./InputBorder.vue?vue&type=script&lang=js"
export * from "./InputBorder.vue?vue&type=script&lang=js"

import "./InputBorder.vue?vue&type=style&index=0&id=2b7af3ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7af3ae"]])

export default __exports__